export default function StocksCloturesConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('stocks.clotures');
}

StocksCloturesConfiguration.$inject = ['$translatePartialLoaderProvider'];
